export interface BaseHostConfig {
  webServer: string;
  cloudServer: string;
  mgrWebServer: string;
  cdnServer: string;
  esService: string;
  tmsServer: string;
  picUrl: string;
  qinsilkUrl: string;
  scmServer: string;
}

export const BASE_URL = {
  webServer: import.meta.env.VITE_WebServer,
  cloudServer: import.meta.env.VITE_CloudServer,
  mgrWebServer: import.meta.env.VITE_MgrWebServer,
  cdnServer: import.meta.env.VITE_CdnServer,
  esService: import.meta.env.VITE_EsService,
  tmsServer: import.meta.env.VITE_TmsServer,
  picUrl: import.meta.env.VITE_PicUrl,
  qinsilkUrl: import.meta.env.VITE_QinsilkUrl,
  scmServer: import.meta.env.VITE_scmServer,
};

export default BASE_URL;
